import { lazy, Suspense } from 'react';
import './App.css';
import {
    Outlet,
    Route,
    RouterProvider,
    ScrollRestoration,
    createBrowserRouter,
    createRoutesFromElements,
    useLocation
} from 'react-router-dom';
import { ModalProvider } from './components/ModalProvider';

import Header from './components/Header';
import Footer from './components/Footer';
import BrowseEvents from './routes/BrowseEvents';
import Subscription from './routes/Subscription';
import Venue from './routes/Venue';
import Gratuit from './routes/Gratuit';
import Familiales from './routes/Familiales';
import ForOrganizers from './routes/ForOrganizers';

const About = lazy(() => import('./routes/About'));
const PrivacyPolicy = lazy(() => import('./routes/PrivacyPolicy'));
const Details = lazy(() => import('./routes/Details'));
const NewEvent = lazy(() => import('./routes/NewEvent'));
const Presse = lazy(() => import('./routes/Presse'));
const MesAlentours = lazy(() => import('./routes/MesAlentours'));
const ThisWeek = lazy(() => import('./routes/ThisWeek'));
const Today = lazy(() => import('./routes/Today'));
const Admin = lazy(() => import('./routes/Admin'));
const InstagramExport = lazy(() => import('./routes/InstagramExport'));

const AppShell: React.FC = () => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith('/admin');
    const isInstagramExport = pathname.startsWith('/instagram-export');

    return (
        <div className="layout">
            <ModalProvider>
                <ScrollRestoration />
                {!isAdmin && !isInstagramExport && <Header />}
                <div id="page" className={isAdmin || isInstagramExport ? 'page-admin' : ''}>
                    <Suspense fallback={<div className="page-skeleton" aria-hidden="true"></div>}>
                        <Outlet />
                    </Suspense>
                </div>
                {!isAdmin && !isInstagramExport && <Footer />}
            </ModalProvider>
        </div>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<AppShell />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/instagram-export" element={<InstagramExport />} />
            <Route path="/" element={<BrowseEvents />} />
            <Route path="/details/:id" element={<Details />} />
            <Route path="/venue/:slug" element={<Venue />} />
            <Route path="/a-propos-de-nous" element={<About />} />
            <Route path="/presse" element={<Presse />} />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/nouveau" element={<NewEvent />} />
            <Route path="/mes-alentours" element={<MesAlentours />} />
            <Route path="/ville-quebec/evenements-cette-semaine" element={<ThisWeek />} />
            <Route path="/ville-quebec/aujourdhui" element={<Today />} />
            <Route path="/ville-quebec/activites-gratuites" element={<Gratuit />} />
            <Route path="/ville-quebec/activites-familiales" element={<Familiales />} />
            <Route path="/abonnement" element={<Subscription />} />
            <Route path="/organisateurs" element={<ForOrganizers />} />
        </Route>
    )
);

const App: React.FC = () => {
    return <RouterProvider router={router} />;
};

export default App;
